<template>
  <div class="main">
    <clouded-glass class="space-choose">
      <div class="h-100 overflow-auto" slot="content">
        <div class="text-lightBlue"
             style="margin: 20px 0 0 25px;cursor: pointer;border-bottom: #07e6f8 1px solid;width: 84px"
           @touchstart="openEditAreaBgImgDialog"  @click="openEditAreaBgImgDialog">编辑区域背景
        </div>
        <div class="current-location">
          <img alt="" src="../../../../assets/images/icon/location.png">
          当前选中:
          <span class="text-nowrap text-lightBlue">{{ checkSpace.cnName }}</span>
        </div>
        <areaTreeShow @spaceChoose="spaceChoose" @changeTierInfo="changeTierInfo" :isOpen="false"
                      :selectTier="selectTier" class="space" ref="tree"/>
      </div>
    </clouded-glass>
    <div class="contentRight">
      <el-row class="text-yellow" style="height: 20px;font-size: 0.8rem">* 单击图标并拖动放置位,双击内景图图标编辑测点</el-row>
      <div class="availableDevice">
        <img :height="45.6" :key="item.id"
             :src="item.status==0?'/static/images/menus/areaIcon.png':'/static/images/menus/areaAlarmIcon.png'"
             :title="item.cnName" :width="33.6"
           @touchstart="setPosition(item)"  @click="setPosition(item)" v-for="item in unBoundDeviceList">
      </div>
      <el-row style="width: 100%;overflow: auto;height: 75.8vh;text-align: center;margin-top: 2vh">
        <!--          内景图-->
        <editIndoorSettingArea v-if="indoorFlag" :selectTier="selectTier" :space-id="checkSpace.id"
                               @changeIndoorLoaded="changeIndoorLoaded"
                               @getUnboundDeviceList="getUnboundDeviceList"
                               @updateIndoorInfo="updateIndoorInfo"
                               ref="editIndoorSetting"/>
      </el-row>
    </div>
    <!-- 编辑区域背景弹框-->
    <editAreaBgImgDialog v-if="areaBgVisible" :divVisible="areaBgVisible" :tierId="checkSpace.id"
                         :selectTier="selectTier"
                         @ChangeInitTree="initTree"
                         @openEditAreaBgImgDialog="openEditAreaBgImgDialog"></editAreaBgImgDialog>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import areaTreeShow from "@/views/basic_operations/device_management/area_map/areaTreeShow";
import editAreaBgImgDialog from "@/views/basic_operations/device_management/area_map/editAreaBgImgDialog";
import editIndoorSettingArea from "@/views/basic_operations/device_management/area_map/EditIndoorSettingArea";

export default {
  name: "Index",
  components: {CloudedGlass, areaTreeShow, editAreaBgImgDialog, editIndoorSettingArea},
  data() {
    return {
      checkSpace: {},
      unBoundDeviceList: [],
      areaBgVisible: false,
      selectTier: null,
      // 判断树节点数据是否加载完成定时器
      edgeTreeLoadedTimer: null,
      // 是否展示内景图
      indoorFlag: false,
      // 判断内景图底图是否加载完成。底图比较大不能一次加载完的时候  是拿不到图片高度的  从而拿不到设备y轴
      indoorLoaded: false
    }
  },
  mounted() {
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
    this.edgeTreeLoadedTimer = setInterval(() => {
      // 如果树节点数据加载完成，渲染内景图
      if (this.selectTier != null) {
        this.indoorFlag = true
        clearInterval(this.edgeTreeLoadedTimer)
        this.edgeTreeLoadedTimer = null;
      }
    }, 1000)
  },
  methods: {
    spaceChoose(spaceInfo) {
      this.checkSpace = spaceInfo;
    },
    getUnboundDeviceList(data) {
      this.unBoundDeviceList = data
    },
    setPosition(item) {
      if (this.indoorLoaded) {
        this.$refs.editIndoorSetting.stopDrag(null, item)
      } else {
        this.$message.info("请等待内景图底图加载完成！")
      }
    },
    // 编辑区域图片弹框
    openEditAreaBgImgDialog() {
      this.areaBgVisible = !this.areaBgVisible;
    },
    // 给树节点子组件调用，更改当前选中层 数据信息
    changeTierInfo(tier) {
      this.selectTier = tier
    },
    // 调用子组件初始化树节点菜单方法
    updateIndoorInfo() {
      this.$refs.tree.updateIndoorInfo()
    },
    // 改变indoorLoaded的方法
    changeIndoorLoaded(flag) {
      this.indoorLoaded = flag
    },
    // 初始化树
    initTree(){
      console.log(12)
      this.$refs.tree.initTree()
    }
  },
  destroyed() {
    clearInterval(this.edgeTreeLoadedTimer)
    this.edgeTreeLoadedTimer = null;
  }
}
</script>

<style scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

/*空间选择*/
.space-choose {
  float: left;
  height: 100%;
  width: 210px;
}

.current-location {
  margin-top: 30px;
  margin-left: 25px;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

.current-location img {
  margin-right: 5px;
}

.space-choose .space {
  margin: 20px 0 10px 30px;
  width: 160px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  font-size: 0.85rem;
  opacity: 1;
}

.contentRight {
  margin-left: 230px;
  width: calc(100vw - 485px);
}

.availableDevice {
  white-space: nowrap; /*不换行*/
  overflow-x: auto;
  margin-top: 10px;
}

.availableDevice img {
  margin: 10px 15px 10px 0;
  cursor: pointer;
}


@media (max-width: 1028px) {
  .main {
    height: auto;
  }

  .space-choose {
    height: auto;
    width: 300px;
    float: none;
    padding-bottom: 10px;
  }

  .contentRight {
    width: 100%;
    height: 100%;
    margin: 20px 0;
  }
}

</style>
